<template>
  <metric-chip v-if="showLegend" :data="seriesWithMeta" />
</template>
<script>
import { calcAggregationStats } from "@/_helpers/aggregationHelper";
import { chartMixin } from "@/_helpers/chartMixin";
import MetricChip from "../../common/MetricChip.vue";

export default {
  name: "ChartLegend",

  components: { MetricChip },
  mixins: [chartMixin],

  props: {
    series: {
      Type: Array,
      default: () => [],
    },
    seriesData: {
      Type: Array,
      default: () => [],
    },
    displayMetas: {
      Type: Object,
      default: {},
    },
    zoomProcent: {
      Type: Object,
      default: () => ({ start: 0, end: 100 }),
    },
    dateRange: {
      Type: Object,
      default: () => {},
    },
  },

  data() {
    return {};
  },

  computed: {
    showLegend() {
      return this.seriesWithMeta.length > 0;
    },

    seriesWithMeta() {
      return (
        this.series
          .filter(
            (x) =>
              this.seriesData[x.slotId]?.length > 0 &&
              this.displayMetas[x.slotId]?.length > 0,
          )
          .map((x) => {
            return {
              slotId: x.slotId,
              name: x.name,
              stats: this.calcValues(
                this.seriesData[x.slotId] ?? [],
                this.displayMetas[x.slotId] ?? [],
                this.zoomProcent,
              ),
            };
          }) ?? []
      );
    },
  },

  methods: {
    calcValues(data, metas, zoom) {
      const selectedData = this.calcZoomedData(data, zoom, this.dateRange).map(
        (x) => {
          return {
            time: this.isVertical ? x.value.at(1) : x.value.at(0),
            value: this.isVertical
              ? Number(x.value.at(0))
              : Number(x.value.at(1)),
          };
        },
      );

      // get stats using the aggregationHelper
      const result = [];
      const stats = calcAggregationStats(
        metas.map((x) => x.type),
        selectedData,
      );
      for (var meta of metas) {
        if (meta?.type == "delta") {
          result.push({
            key: meta.key,
            value:
              selectedData?.at(selectedData?.length - 1)?.value -
              selectedData.at(0)?.value,
          });
          continue;
        }
        result.push({ key: meta.key, value: stats[meta.type] });
      }

      return result;
    },
  },
};
</script>
